import { useDispatch } from 'react-redux';
import { clearLastExchange } from '../../../../../Checkout/store/order/actions';
export function useClearLastExchange() {
    const dispatch = useDispatch();
    const onClearLastExchange = () => {
        dispatch(clearLastExchange());
    };
    return { onClearLastExchange };
}
